import React, { useMemo } from "react";
import Tree from "../../../../Components/Tree/Tree";
import { buildAffectedHierarchy } from "./buildAffectedHierarchy";
import type { AffectedHierarchy, ScopeNodeType } from "./types";
import "./AffectedScopesHierarchy.scss";
import { IN_USE_TOOLTIP } from "./scopeTreeUtils";

export interface AffectedScopesHierarchyProps {
  hierarchy: AffectedHierarchy;
  title?: string;
}

const DEFAULT_TITLE = "Affected scopes hierarchy";

// Scopes are the resources the action touches; groups only frame them.
const HIGHLIGHTED_TYPE: ScopeNodeType = "scope";

const AffectedScopesHierarchy: React.FC<AffectedScopesHierarchyProps> = ({
  hierarchy,
  title = DEFAULT_TITLE,
}) => {
  const view = useMemo(() => buildAffectedHierarchy(hierarchy), [hierarchy]);
  if (!view) {
    return null;
  }
  const { nodes, inUseIds } = view;
  return (
    <div
      className={"affected-scopes-hierarchy"}
      data-testid={"affected-scopes-hierarchy"}
    >
      <div className={"affected-scopes-hierarchy-title"}>{title}</div>
      <Tree
        data={nodes}
        className={"affected-scopes-hierarchy-tree"}
        isStatic
        readOnly
        isHighlightedNode={(node) => node.type === HIGHLIGHTED_TYPE}
        nodeOperations={{ onWarning: (id) => inUseIds.has(String(id)) }}
        warningTooltip={IN_USE_TOOLTIP}
        data-testid={"affected-scopes-hierarchy-tree"}
      />
    </div>
  );
};

export default AffectedScopesHierarchy;
